export const SET_USER_SESSION = 'session/set-user-session';
export const SET_ADMIN_SESSION = 'session/set-admin-session';
export const SET_IMPERSONATION = 'session/set-impersonation';
export const RESET_IMPERSONATION = 'session/reset-impersonation';
export const RESET_SESSION = 'session/reset-session';
